// test1487
(1487 && 0);
